import { Navigate, Route, Routes, useParams } from "react-router";

import {
  BASE_URL,
  CONTACT_DETAILS_URL,
  POD_URL,
  CALENDAR_URL,
  PRODUCT_SELECTION_URL,
  ORDER_CONFIRMATION_URL,
  ORDER_URL,
} from "./urls";
import Home from "../modules/Home/Home";
import Registration from "../modules/Registration/Registration";
import ContactDetails from "../modules/ContactDetails/ContactDetails";
import ProductSelection from "../modules/ProductSelection/ProductSelection";
import OrderConfirmation from "../modules/OrderConfirmation/OrderConfirmation";
import Order from "../modules/Order/Order";
import { AppDispatch, RootState } from "../store";
import { useDispatch, useSelector } from "react-redux";
import { podActions } from "../store/slices/PODSlice";
import React from "react";

const Resource: React.FC<any> = ({ page }) => {
  const { resourceName, podId, eventId } = useParams();
  const dispatch: AppDispatch = useDispatch();
  if (resourceName) {
    dispatch(podActions.setResourceName(resourceName));
    localStorage.setItem("resourceName", resourceName);
  }
  if (page === PRODUCT_SELECTION_URL) {
    return (
      <Navigate
        to={`${BASE_URL}/${resourceName}/${POD_URL}/${podId}/event/${eventId}/${PRODUCT_SELECTION_URL}${window.location.search}`}
        replace
      />
    );
  } else {
    return (
      <Navigate
        to={`${BASE_URL}/${resourceName}/${POD_URL}/${podId}${window.location.search}`}
        replace
      />
    );
  }
};

const Router = () => {
  const resourceName = useSelector(
    (state: RootState) => state.pod.resourceName
  );

  return (
    <Routes>
      <Route
        path={`${BASE_URL}/:resourceName/${POD_URL}/:podId`}
        element={<Resource />}
      />
      <Route
        path={`${BASE_URL}/:resourceName/${POD_URL}/:podId/event/:eventId/${PRODUCT_SELECTION_URL}`}
        element={<Resource page={PRODUCT_SELECTION_URL} />}
      />
      <Route
        path={`${BASE_URL}/:resourceName/${POD_URL}/:podId/${CALENDAR_URL}`}
        element={<Resource page={CALENDAR_URL} />}
      />
      <Route path='*' element={<Navigate to={BASE_URL} replace />} />
      <Route
        path={`${BASE_URL}/${resourceName}/${POD_URL}/:podId`}
        element={<Home />}>
        <Route index element={<Registration />} />
        <Route
          path={`event/:eventId/${CONTACT_DETAILS_URL}`}
          element={<ContactDetails />}
        />
        <Route
          path={`event/:eventId/${PRODUCT_SELECTION_URL}`}
          element={<ProductSelection />}
        />
        <Route
          path={`event/:eventId/${ORDER_CONFIRMATION_URL}/:orderId`}
          element={<OrderConfirmation />}
        />
        <Route path={ORDER_URL + "/:orderId"} element={<Order />} />
      </Route>
    </Routes>
  );
};

export default Router;
